/*
 * @Descripttion: 获取vue全局实例
 * @version: 1.0.1
 * @Author: echo
 * @Date: 2022-03-25 19:17:34
 * @LastEditors: echo
 * @LastEditTime: 2022-03-26 03:55:59
 */
import { type ComponentInternalInstance, getCurrentInstance } from 'vue'

export const useCurrentInstance = () => {
  const { appContext } = getCurrentInstance() as ComponentInternalInstance
  const globalProperties = appContext.config.globalProperties
  return {
    globalProperties
  }
}
